import { useLoaderData, useOutletContext } from "react-router-dom";
import DisplayCupBrowse from "../../track-components/DisplayCupBrowse";
import { Link } from "react-router-dom";
import Button from "../../Button/Button";
import "./Browse.css";
import { useLayoutEffect, useState } from "react";
import SmallPop from "../../pops/SmallPop";

export default function BrowseCupId() {
    const [width] = useOutletContext();
    const data = useLoaderData();
    const [smallPop, setSmallPop] = useState();

    useLayoutEffect(() => {
        const timeout = setTimeout(() => {
            setSmallPop(null);
        }, 3500);

        return () => clearTimeout(timeout);
    }, [smallPop]);


    return <div id="main-container">
        <div id="found-cup-container">
            {data?.tracks.length > 0 && <>
               <h3>{data?.cupName}</h3>
               <DisplayCupBrowse tracks={data?.tracks} width={width} /> 
            </>}
            <div className="cup-creator">
                <Link reloadDocument to={`/profile/${data?.creatorId}`}
                    className="cup-creator"
                    title={`Go to ${data?.creator}'s profile`}>
                    <img src={require("../../../assets/icons/profile-white.png")}
                        alt="profile icon" />
                    <p>{data?.creator}</p>
                </Link>
            </div>

            <Button text="Share" icon={require("../../../assets/icons/icons8-share-50.png")}
                disabled={!data?.id.length}
                onClick={(e) => {
                    e.preventDefault();
                    navigator.clipboard.writeText("https://mk8dx-cup-builder.web.app" 
                        + `/browse/cup/${data?.id}`);
                    setSmallPop(true);
                }} />
            {
                smallPop && <SmallPop text="Copied URL to clipboard!"/>
            }
        </div>
    </div>;
}